module.exports = __webpack_public_path__ + "img/safari_tips_cn.1b0c8dbe.png";